// Admin widget registry (H.3.4a) — name → React component, supplied to the
// MarkdownRenderer via WidgetRegistryProvider in routes/Chat.tsx. web-admin
// previously had NO registry; these are the four admin chat widgets.
import type { WidgetRegistry, WidgetComponent } from '@rmint/shell';
import { FounderDecision } from '../components/widgets/FounderDecision';
import { KycDecision } from '../components/widgets/KycDecision';
import { OfficerQueue } from '../components/widgets/OfficerQueue';
import { ScanResult } from '../components/widgets/ScanResult';

// The renderer passes a flat `WidgetProps` (Record<string, unknown>) record;
// each widget declares its own narrow prop subset. The `as unknown as
// WidgetComponent` cast bridges the two — same pattern as web-outreach's
// registry (the runtime props arrive as a loose dict regardless).
export const adminWidgetRegistry: WidgetRegistry = {
  'founder-decision': FounderDecision as unknown as WidgetComponent,
  'kyc-decision': KycDecision as unknown as WidgetComponent,
  'officer-queue': OfficerQueue as unknown as WidgetComponent,
  'scan-result': ScanResult as unknown as WidgetComponent,
};
